import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  ButtonBase,
  Checkbox,
  Divider,
  FormControlLabel,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { colors } from "src/config/colors";
import { Control, Controller } from "react-hook-form";
import { FilterFields } from "src/components/BrandCategoryPage/components/MainBrandSection/components/Filters/FiltersList";
import { Theme } from "@mui/system";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface FilterProps {
  title: string;
  control: Control<FilterFields, Object>;
  filterData: string[];
  controllerName: "forms" | "dosages" | "packagins";
}

export const Filter: React.FC<FilterProps> = ({
  title,
  control,
  filterData,
  controllerName,
}) => {
  const [isOpenList, setOpenList] = useState<boolean>(false);

  const isLargeScreenDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg")
  );

  const [isExpanded, setExpanded] = useState<boolean>(false);

  const handleChange = () => () => {
    setExpanded((prevState) => !prevState);
  };

  if (filterData.length === 0) return null;

  const FILTERS_LIMIT = 6;

  return (
    <>
      <Accordion
        disableGutters
        expanded={isLargeScreenDown || isExpanded}
        onChange={handleChange()}
        sx={{
          boxShadow: "none",
          width: "100%",
          ":before": {
            display: "none",
          },
        }}
      >
        <AccordionSummary
          sx={{
            padding: 0,
            ".MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
          expandIcon={
            <ExpandMoreIcon
              sx={{
                display: isLargeScreenDown ? "none" : "flex",
                color: colors.darkBlue,
              }}
            />
          }
        >
          <Typography
            component="h6"
            sx={{
              fontSize: { xs: "14px", md: "16px" },
              color: colors.black2,
              fontWeight: 400,
              mb: isLargeScreenDown ? 2 : 0,
            }}
          >
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails
          sx={{
            padding: "0",
            border: "none",
          }}
        >
          <Controller
            control={control}
            name={controllerName}
            render={({ field: { onChange, value } }) => (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height:
                    filterData.length < FILTERS_LIMIT
                      ? "100%"
                      : isOpenList
                      ? "300px"
                      : "255px",
                  transition: "height 500ms ease",
                  width: "100%",
                  overflow: isOpenList ? "auto" : "hidden",
                  "::-webkit-scrollbar": {
                    width: "4px",
                  },
                  "::-webkit-scrollbar-track": {
                    width: "4px",
                    backgroundColor: "#DADADA",
                    borderRadius: "5px",
                  },
                  "::-webkit-scrollbar-thumb": {
                    borderRadius: "5px",
                    width: "4px",
                    backgroundColor: "#3C56CB",
                  },
                }}
              >
                {filterData.map((filterDataValue) =>
                  filterDataValue ? (
                    <FormControlLabel
                      sx={{
                        ".MuiFormControlLabel-label": {
                          color: colors.black2,
                          fontSize: "12px",
                          lineHeight: "14px",
                        },
                        ".MuiCheckbox-root.Mui-checked": {
                          color: colors.blue2,
                        },
                        ".MuiCheckbox-root": {
                          color: colors.blue2,
                        },
                      }}
                      key={filterDataValue}
                      label={filterDataValue}
                      checked={value?.includes(filterDataValue)}
                      onChange={(event, checked) => {
                        if (checked) {
                          onChange([...value, filterDataValue]);
                        } else {
                          onChange(
                            value.filter((value1) => value1 !== filterDataValue)
                          );
                        }
                      }}
                      control={<Checkbox disableRipple />}
                    />
                  ) : null
                )}
              </Box>
            )}
          />
          {filterData.length > FILTERS_LIMIT && (
            <ButtonBase
              onClick={() =>
                !isOpenList ? setOpenList(true) : setOpenList(false)
              }
              sx={{
                ":hover": {
                  backgroundColor: "#fff",
                },
                width: "fit-content",
                color: colors.blue2,
                mt: 2,
              }}
            >
              {!isOpenList ? "Показать всё" : "Свернуть"}
            </ButtonBase>
          )}
        </AccordionDetails>
      </Accordion>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Filter;

/*return (
  <>
    <Box>
      <Typography
        component="h6"
        sx={{
          fontSize: { xs: "14px", md: "16px" },
          color: colors.black2,
          fontWeight: 400,
          mb: 2,
        }}
      >
        {title}
      </Typography>
      <Controller
        control={control}
        name={controllerName}
        render={({ field: { onChange, value } }) => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              height:
                filterData.length < FILTERS_LIMIT
                  ? "100%"
                  : isOpenList
                    ? "300px"
                    : "255px",
              transition: "height 500ms ease",
              width: "100%",
              overflow: isOpenList ? "auto" : "hidden",
              "::-webkit-scrollbar": {
                width: "4px",
              },
              "::-webkit-scrollbar-track": {
                width: "4px",
                backgroundColor: "#DADADA",
                borderRadius: "5px",
              },
              "::-webkit-scrollbar-thumb": {
                borderRadius: "5px",
                width: "4px",
                backgroundColor: "#3C56CB",
              },
            }}
          >
            {filterData.map((filterDataValue) =>
              filterDataValue ? (
                <FormControlLabel
                  sx={{
                    ".MuiFormControlLabel-label": {
                      color: colors.black2,
                      fontSize: "12px",
                      lineHeight: "14px",
                    },
                    ".MuiCheckbox-root.Mui-checked": {
                      color: colors.blue2,
                    },
                    ".MuiCheckbox-root": {
                      color: colors.blue2,
                    },
                  }}
                  key={filterDataValue}
                  label={filterDataValue}
                  checked={value?.includes(filterDataValue)}
                  onChange={(event, checked) => {
                    if (checked) {
                      onChange([...value, filterDataValue]);
                    } else {
                      onChange(
                        value.filter((value1) => value1 !== filterDataValue)
                      );
                    }
                  }}
                  control={<Checkbox disableRipple />}
                />
              ) : null
            )}
          </Box>
        )}
      />
    </Box>
    {filterData.length > FILTERS_LIMIT && (
      <ButtonBase
        onClick={() => (!isOpenList ? setOpenList(true) : setOpenList(false))}
        sx={{
          ":hover": {
            backgroundColor: "#fff",
          },
          width: "fit-content",
          color: colors.blue2,
          mt: 2,
        }}
      >
        {!isOpenList ? "Показать всё" : "Свернуть"}
      </ButtonBase>
    )}
    <Divider sx={{ my: 2 }} />
  </>
);*/
